import React, { useContext, useEffect, useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import {
  Table, Space, Popconfirm, Button, Input,
} from 'antd';
import moment from 'moment';
import { useDispatch } from 'react-redux';

import { VerticalContainer } from '../../../components/styled';
import { UserContext } from '../../../context';
import history from '../../../routes/history';
import {
  getProfissionais,
  deleteProfissional,
} from '../../../services/profissional';
import { Creators as ProfissionalActions } from '../../../store/ducks/profissional';

const { Search } = Input;
const { Column } = Table;
export default function ListProfissionais() {
  const user = useContext(UserContext);
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(false);
  const [profissionais, setProfissionais] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(10);
  const dispatch = useDispatch();
  const getProfissionaisPaginated = async () => {
    try {
      setLoading(true);
      const profissionaisData = await getProfissionais(page, filter);
      setProfissionais(profissionaisData.data);
      setTotal(profissionaisData.total);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProfissionaisPaginated();
  }, [page, filter]);

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
  };
  async function confirm(record) {
    await deleteProfissional(record.id);
    await getProfissionaisPaginated();
    dispatch(ProfissionalActions.getAllProfissionalRequest());
  }

  function cancel(e) {
    console.log(e);
  }

  const onSearch = (value) => {
    setFilter(value);
  };
  const onChange = (e) => {
    if (!e.target.value) setFilter('');
  };

  return (
    <>
      <VerticalContainer>
        <Search
          onChange={onChange}
          style={{ width: '50%' }}
          placeholder="Pesquisar profissional, registro, email"
          enterButton="Pesquisar"
          onSearch={onSearch}
          size="middle"
        />
        <br />
        <Button
          type="dashed"
          onClick={() => {
            history.push('adicionar-profissional');
          }}
          style={{ width: '100%!important' }}
          block
        >
          <PlusOutlined />
          Adicionar profissional
        </Button>
        <br />
        <Table
          size="middle"
          pagination={{ pageSize: 10, total }}
          onChange={handleTableChange}
          style={{ width: '100%' }}
          dataSource={profissionais}
          rowKey="id"
          loading={loading}
        >
          <Column title="Código" dataIndex="id" key="id" />
          <Column
            title="Nome"
            dataIndex={['pessoa_fisica', 'nome']}
            key="nome"
          />
          <Column
            title="Email"
            dataIndex={['pessoa_fisica', 'email']}
            key="email"
          />
          <Column
            title="Data de criação"
            dataIndex="created_at"
            render={(data) => moment(data).format('DD/MM/YYYY')}
            key="created_at"
          />
          <Column
            title="Ação"
            key="action"
            render={(text, record) => (
              <Space size="middle">
                <a onClick={() => history.push(`profissionais/${record.id}`)}>
                  Visualizar
                </a>
                {user?.type === 'ADM'
                && (
                <Popconfirm
                  title="Deseja deletar o profissional?"
                  onConfirm={() => confirm(record)}
                  onCancel={cancel}
                  okText="Sim"
                  cancelText="Não"
                >
                  <a>Deletar</a>
                </Popconfirm>
                )}
              </Space>
            )}
          />
        </Table>
      </VerticalContainer>
    </>
  );
}
